import MainMenu from './components/main-menu';
import Header from './components/header';
import { Tooltip } from './bootstrap.js';
import PhotoSwipeTheme from './components/photoswipe';
import FlickityInnerSliderOptions from './components/flickity-inner-slider-options';
import MasonryOptions from './components/masonry-options';
import MasonryGallery from './components/masonry-gallery';
import resizeFlickityInnerSlider from './components/resize-flickity-inner-slider';
import doubleFlickitySlider from './components/double-flickity-slider';
import IsotopeListing from './components/isotope-listing';
import compareRooms from './components/room-compare';
import AccordionSection from './components/accordion-button';
import HeroVideo from './components/hero-video';

/**
 * Calls a supplied function once
 * document has loaded.
 *
 * @param  {CallableFunction} onLoaded
 * @return {void}
 */
const domLoaded = (onLoaded) => {
	if (document.readyState !== 'loading') {
		// Document is already ready, call the callback directly
		onLoaded();
	} else if (document.addEventListener) {
		// All modern browsers to register DOMContentLoaded
		document.addEventListener('DOMContentLoaded', onLoaded);
	} else {
		// Old IE browsers
		document.attachEvent('onreadystatechange', function () {
			if (document.readyState === 'complete') {
				onLoaded();
			}
		});
	}
};

const App = {
	init() {
		// const burgerButton = new BurgerButton();
		const mainMenu = new MainMenu();
		const header = new Header();

		// Photoswipe
		Array.from(document.querySelectorAll('.pswp-gallery')).map(el => new PhotoSwipeTheme(el));

		// Flickity
		Array.from(document.querySelectorAll('.inner-slideshow')).map(el => new FlickityInnerSliderOptions(el));

		// Double Flickity Slider
		Array.from(document.querySelectorAll('.slideshow-text')).map(el => new doubleFlickitySlider(el));

		//Element Filtering
		Array.from(document.querySelectorAll('.filters')).map(el => new MasonryOptions(el));

		// Masonry Gallery
		Array.from(document.querySelectorAll('.masonry-gallery')).map(el => new MasonryGallery(el));

		// Isotope Listing
		Array.from(document.querySelectorAll('.isotope-listing')).map(el => new IsotopeListing(el));

		// Flickity Prompt Resize
		Array.from(document.querySelectorAll('.inner-slider')).map(el => new resizeFlickityInnerSlider(el));

		// Room Compare Functionality
		const roomForm = document.getElementById('room-compare-form');
		if (roomForm) {
			const roomComparison = new compareRooms();
		}

		//Tooltip
		let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
		tooltipTriggerList.map(function (tooltipTriggerEl) {

			return new Tooltip(tooltipTriggerEl);
		});

		//Read more buttons
		const readMoreButtons = document.querySelectorAll('.read-more-toggle-link');
		readMoreButtons.forEach( el => {

			el.addEventListener('click', function(e) {

				e.preventDefault();

				const target = document.querySelector(el.dataset.toggle);
				const moreLabel = el.dataset.open_text;
				const lessLabel = el.dataset.close_text;
				const maxHeight = el.dataset.max_height;

				//calculate max height


				if (target.classList.contains("show")) {
					target.classList.remove('show');
					target.style.maxHeight = maxHeight;
					el.querySelector(`.label`).innerHTML = moreLabel;
					el.querySelector(`.icon-open`).classList.add('d-none');
					el.querySelector(`.icon-close`).classList.remove('d-none');
				}
				else {
					target.classList.add('show');
					target.style.maxHeight = `${target.scrollHeight}px`;
					el.querySelector(`.label`).innerHTML = lessLabel;
					el.querySelector(`.icon-open`).classList.remove('d-none');
					el.querySelector(`.icon-close`).classList.add('d-none');
				}
			})

		});

		// .cv fields
		const cvInput = document.querySelector('.cv');
		function checkFile() {
			if (cvInput.files.length !== 0) {
				cvInput.classList.add('add-file');
			}
		}
		if (cvInput != null) {
			cvInput.addEventListener('change', checkFile);
			checkFile();
		}

		// add custom window sizes for cv field
		function handleResize() {
			const windowWidth = window.innerWidth;
			if (cvInput == null) return;
			if (windowWidth <= 1400) {
				cvInput.classList.add('add-file-one');
			} else {
				cvInput.classList.remove('add-file-one', 'add-file-two', 'add-file-three', 'add-file-four');
			}
			if (windowWidth <= 1203) {
				cvInput.classList.add('add-file-two');
				cvInput.classList.remove('add-file-one');
			} else {
				cvInput.classList.remove('add-file-one', 'add-file-two', 'add-file-three', 'add-file-four');
			}
			if (windowWidth <= 991) {
				cvInput.classList.add('add-file-three');
				cvInput.classList.remove('add-file-one', 'add-file-two');
			} else {
				cvInput.classList.remove('add-file-one', 'add-file-two', 'add-file-three', 'add-file-four');
			}
			if (windowWidth <= 768) {
				cvInput.classList.add('add-file-one');
				cvInput.classList.remove('add-file-two', 'add-file-three');
			} else {
				cvInput.classList.remove('add-file-one', 'add-file-two', 'add-file-three', 'add-file-four');
			}
			if (windowWidth <= 400) {
				cvInput.classList.add('add-file-four');
				cvInput.classList.remove('add-file-one', 'add-file-two', 'add-file-three');
			} else {
				cvInput.classList.remove('add-file-one', 'add-file-two', 'add-file-three', 'add-file-four');
			}
		}
		window.addEventListener("resize", handleResize);
		handleResize();

		// ---------- Accordion Room Features ----------
		Array.from(document.querySelectorAll('.accordion')).map(el => new AccordionSection(el));

		// ---------- Book Now Dropdown ----------------
		const webHotelierElements = document.getElementsByClassName("webhotelier-link");
		if (webHotelierElements) {
			Array.from(webHotelierElements).forEach(function(element) {
				element.addEventListener('click', function () {
					let x = this.getElementsByClassName("more-buttons")[0];
					if (x.style.pointerEvents === "none" || x.style.pointerEvents === "") {
						x.style.pointerEvents = "auto";
						x.style.maxHeight = "10rem";
						x.style.border = "1px solid black";
						x.style.borderTop = "0";
					} else {
						x.style.pointerEvents = "none";
						x.style.maxHeight = "0rem";
						x.style.border = "";
						x.style.borderTop = "";
					}
				});
			});
		}

		let location_btn = Array.from(document.querySelectorAll('.routes-tab .routes-tab-item-action'));
		let maps = Array.from(document.querySelectorAll('.map-embed'));

		if (location_btn && maps){
			for ( let i=0; i < location_btn.length; i++) {
				location_btn[i].addEventListener('click', function (e) {
					for ( let m=0; m < maps.length; m++) {
						if ( maps[m].getAttribute('id') == `map-${i}` ){
							maps[m].classList.remove('d-none');
						}else{
							maps[m].classList.add('d-none');
						}
					}
				});
			}
		}

		// breadcrumbs on top
		const sectionTitle = document.querySelector(".entry-header");
		const sectionBread = document.querySelector(".yoast-breadcrumbs");
		sectionTitle && sectionBread && sectionBread.append(sectionTitle);

		if (document.getElementById('hero-video')) {
			const heroVideo = new HeroVideo(document.getElementById('hero-video'));
		}

		Array.from(document.querySelectorAll(".tab-title")).map(el => {
			el.addEventListener('click', function(ev) {
				const elIndex = Array.prototype.indexOf.call(el.parentNode.children,el);

				// Remove the 'active' class from all tabs and tab contents
				Array.from(document.querySelectorAll(".tab-title")).map(e => e.classList.remove("active"));
				Array.from(document.querySelectorAll(".tab-content")).map(e => e.classList.remove("active"));

				// Add the 'active' class to the clicked tab and corresponding content
				el.classList.add("active");
				Array.from(document.querySelectorAll(".tab-content"))[elIndex].classList.add("active");
			});
		});

		if (document.querySelector("#check-in-link a")) {
			document.querySelector("#check-in-link a").setAttribute('target', '_blank');
		}
	}
};

domLoaded(() => {
	App.init();
});
